// extracted by mini-css-extract-plugin
export default {"listingDetail":"index_listingDetail__5pgNU","listSingle":"index_listSingle__MsNuC"};